



















































import Vue from "vue"
import http from "../../plugins/http";
import { Menu } from "../../modules/Menu";
import * as Common from "../../commons/common";

export type DataType = {
  errors: string[]
  loginId: string
  email: string
  phone_no: string
};

export default Vue.extend({
  name: "SignIn",
  data(): DataType {
    return {
      errors: [],
      loginId: "",
      email: "",
      phone_no: "",
    };
  },
  mounted() {
    this.$store.commit("setNendo", Number(this.$route.params.nendo));
    this.$store.commit("setIsHeaderDisp", false);
  },
  beforeDestroy() {
    this.$store.commit("setIsHeaderDisp", true);
  },
  methods: {
    // ログインボタン押下
    onSubmit(){
      
      this.errors = [];

      if(!this.loginId){
        this.errors.push("ログインIDを入力してください。");
        return;
      }

      if(!this.email){
        this.errors.push("メールアドレスを入力してください。");
        return;
      }

      if(!this.phone_no){
        this.errors.push("電話番号を入力してください。");
        return;
      }

      http.post("/api/login/practice_examinee", {condition: {nendo: this.$store.state.nendo, login_id: this.loginId, email: this.email, phone_no: this.phone_no}}).then(response => {
        this.executeLogin(response);
      })
      .catch(error=>{
        if (error.response.status == 401) {
          this.errors.push("ログインに失敗しました。受験番号・メールアドレス・電話番号を確認してください。");
        }
        if (error.response.status == 403) {
          this.errors.push("試行回数の制限を超えました。管理者に問い合わせてください。");
        }
        if (error.response.status == 406) {
          this.errors.push("現在メンテナンス中のためログインできません。");
        }
        if (error.response.status == 410) {
          this.errors.push("成績情報が公開されていません。公開後にログインできるようになりますので、今しばらくお待ちください。");
        }
      });
    },
    // ログイン成功後の後処理
    executeLogin(response: any){
      var user = response.data.user;

      // トークン設定
      var token = user.access_token
      document.cookie = `access_token=${token}`;

      this.$store.commit("setCurrentUser", user);
      this.$store.commit("setCurriculums", response.data.curriculums);
      this.$store.commit("setPracticeExaminee", response.data.practice_examinee);

      if(response.data.practice_examinee.passing_state_fixed != null){
        // 合格判定画面へ
        this.$router.push(`/candidate/result_top/${response.data.practice_examinee.id}`).catch(err => {});
      }else{
        // 合否判定が未登録の場合、成績画面へ
        this.$router.push(`/candidate/result_list/${response.data.practice_examinee.id}`).catch(err => {});
      }
    }
  }
})
